<template>
  <div class="menuitems-main">
    <div
      class="cat-menu-cls"
      :class="newCateClassAdd"
      v-if="is_menu_category && cateMenus && cateMenus.length > 0"
    >
      <nav class="category-menu-item-main px-0">
        <menu-category
          v-for="catmenu in cateMenus"
          :key="'a' +catmenu.id"
          :menu="catmenu"
          v-on:setCategoryMenuId="openMenuCategoryList"
          :pagename="pageName"
        ></menu-category>
      </nav>
    </div>

    <div class="menu-class-sticky">
      <div
        class="sidebar"
        id="side-bar"
        v-if="listItemVeg.length > 0 || restTags.length > 0"
      >
        <nav class="navigation extr-tags-list" id="menulist1">
          <ul class="mb-0 py-2">
            <li class="d-flex align-items-center">
              <div v-for="(list, i) in listItemVeg" class="tagslist" :key="'b' + i">
                <a
                  href="javascript:void(0);"
                  :id="'menuitem' + i"
                  class="rmvactv"
                  :class="
                    selectType.length > 0 && selectType.includes(list)
                      ? list == '0'
                        ? 'green'
                        : list == '1'
                        ? 'red'
                        : ''
                      : ''
                  "
                  v-if="list != 2"
                  @click="itemFilterClick(list, 'oldtag')"
                  >{{ list == "0" ? "Veg" : list == "1" ? "Non-veg" : "" }}</a
                >
              </div>
              <div
                v-for="(tag, index) in restTags"
                class="tagslist"
                :key="'c' + index"
              >
                <a
                  href="javascript:void(0);"
                  :id="'menuitem' + tag.name"
                  class="rmvactv"
                  @click="itemFilterClick(tag.name, 'newtag')"
                  :style="[
                    selectType.includes(tag.name)
                      ? {
                          background:
                            '' + tag.background_color + '!important' + '',
                          color: tag.text_color + '!important',
                        }
                      : '',
                  ]"
                  >{{ tag.name }}</a
                >
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="menuitems-main-wrapper d-xl-flex">
      <!-------nav bar start------->
      <div class="side-menu-main">
        <ul id="menulist" role="tablist" aria-orientation="vertical">
          <li v-if="recommendedList && recommendedList.length > 0" class="mb-0">
            <button
              class="nav-link w-100 py-2 px-3 text-start rmvactv 80 side-menu-link active"
              id="menuitem0"
              data-bs-toggle="pill"
              data-bs-target="#item0"
              v-if="
                $auth.setting &&
                $auth.setting.recommended_menu_name &&
                $auth.setting.recommended_menu_name.length > 0
              "
              type="button"
              role="tab"
              aria-controls="item0"
              aria-selected="false"
            >
              {{ $t($auth.setting.recommended_menu_name) }}
            </button>
            <button
              class="nav-link w-100 py-2 px-3 text-start rmvactv 80 side-menu-link active"
              id="menuitem0"
              data-bs-toggle="pill"
              data-bs-target="#item0"
              v-else
              type="button"
              role="tab"
              aria-controls="item0"
              aria-selected="false"
            >
              {{ $t("Recommended") }}
            </button>
          </li>

          <li v-for="(menu, index) in filteredData" :key="'d' + index" class="mb-0">
            <button
              class="nav-link w-100 py-2 px-3 text-start rmvactv 80 side-menu-link"
              :class="{ active: recommendedList.length <= 0 && index == 0 }"
              :id="'menuitem' + menu.restaurant_menu_id"
              data-bs-toggle="pill"
              :data-bs-target="'#item' + menu.restaurant_menu_id"
              type="button"
              role="tab"
              :aria-controls="'item' + menu.restaurant_menu_id"
              aria-selected="false"
              @click="activeMenu(menu.restaurant_menu_id)"
            >
              {{ menu.menu_name }}
            </button>
          </li>
          <template v-if="menus.length == 0 && is_menu_skel_loader">
            <li v-for="mn in 6" :key="'e' + mn">
              <skeleton-loader-vue
                type="string"
                width="100%"
                height="29px"
                class="rmvactv 88 side-menu-link"
              />
            </li>
          </template>
        </ul>
      </div>
      <!-------navbar end----------->

      <div class="main-content w-100 flex-grow-1 d-flex flex-column">
        <!-----skeleton Start layout-1---------->
        <div v-if="is_menu_skel_loader" class="menulength " id="itemmenumain">
          <section>
            <div class="media-heading">
              <h4 class="mb-4">
                <skeleton-loader-vue type="string" width="24%" height="20px" />
              </h4>
            </div>
            <div class="media-itms media-itms-theme5">
              <div
                class="item_detail noImgClass"
                right="true"
                v-for="prdt in 4"
                :key="'f' + prdt"
              >
                <div class="media">
                  <a
                    href="javascript:void(0)"
                    id="element"
                    class="btn btn-default show-modal"
                  >
                    <div class="media-body">
                      <h5 class="mt-0 me-5 item-name">
                        <skeleton-loader-vue
                          type="string"
                          width="24%"
                          height="20px"
                        />
                      </h5>
                      <div class="prc-show">
                        <span class="mt-2 d-inline-block item-price">
                          <skeleton-loader-vue
                            type="string"
                            width="54px"
                            height="24px"
                          />
                        </span>
                      </div>
                      <p class="mb-0 mt-2 item-descr">
                        <skeleton-loader-vue
                          type="string"
                          width="100%"
                          height="20px"
                        />
                      </p>
                    </div>
                  </a>
                  <div class="img-btn">
                    <div class="item-img itemimg-squre">
                      <skeleton-loader-vue
                        width="120"
                        height="120"
                        class="img-cls"
                        style="border-radius: 5px"
                      />
                    </div>
                    <div class="pgnme-cls btn-top">
                      <div class="nw-itm-btn">
                        <div class="sold-de">
                          <div class="icus">
                            <button class="btn btn-sm">
                              <skeleton-loader-vue
                                type="string"
                                width="50px"
                                height="24px"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <!-----skeleton End layout-1---------->

        <!-- Main Content Area -->
        <div v-if="!is_menu_skel_loader" class="menulength h-100" id="itemmenumain">
          <!--- Show when there are items --->
          <div v-if="hasItemsToDisplay">
            <!--Recommended Item Start------>
            <div class="tab-content" id="v-pills-tabContent">
              <section
                v-if="recommendedList.length > 0"
                id="item0"
                class="tab-pane fade show active"
                role="tabpanel"
                aria-labelledby="menuitem0"
                :key="'recommended'"
              >
                <div class="media-heading">
                  <h4 class="mb-4">
                    {{
                      $t($auth.setting.recommended_menu_name || "Recommended")
                    }}
                  </h4>
                </div>
                <div
                  class="media-itms"
                  :class="
                    'media-itms-theme' +
                    (itemlayout == null || itemlayout == '' ? '1' : itemlayout)
                  "
                >
                  <Product
                    v-for="(item, k) in recommendedList"
                    :key="'g' + k"
                    :item="item"
                    :right="true"
                    menuId="0"
                    v-on:openProductDetailModal="openProductDeails"
                    :restaurantID="item.restaurant_id"
                    :restaurant_on_off="restaurant_on_off"
                    :class="item.item_id"
                    :pagename="pageName"
                    :itemlayout="
                      itemlayout == null || itemlayout == '' ? '1' : itemlayout
                    "
                    :restautantDetails="restautantDetails"
                  ></Product>
                </div>
              </section>

              <template v-for="(menuData, index) in filteredData">
                <section
                  :id="'item' + menuData.restaurant_menu_id"
                  v-if="menuData.items.length > 0"
                  :ref="'item' + menuData.restaurant_menu_id"
                  class="tab-pane fade pt-4"
                  role="tabpanel"
                  :aria-labelledby="'menuitem' + menuData.restaurant_menu_id"
                  tabindex="0"
                  :class="{
                    'show active': recommendedList.length <= 0 && index == 0,
                  }"
                  :key="index"
                >
                  <div class="media-heading">
                    <h4 class="mb-4">{{ menuData.menu_name }}</h4>
                  </div>
                  <div
                    class="media-itms"
                    :class="
                      'media-itms-theme' +
                      (itemlayout == null || itemlayout == ''
                        ? '1'
                        : itemlayout)
                    "
                  >
                    <Product
                      v-for="item in menuData.items"
                      :key="item.item_id"
                      :item="item"
                      :right="true"
                      :menuId="menuData.restaurant_menu_id"
                      v-on:openProductDetailModal="openProductDeails"
                      :restaurantID="item.restaurant_id"
                      :restaurant_on_off="restaurant_on_off"
                      :class="item.item_id"
                      :pagename="pageName"
                      :itemlayout="
                        itemlayout == null || itemlayout == ''
                          ? '1'
                          : itemlayout
                      "
                      :restautantDetails="restautantDetails"
                    ></Product>
                  </div>
                </section>
              </template>
            </div>
          </div>

          <!---Category wise Menu item Open--->
          <div v-else-if="menusdata && filteredItemData.length">
            <section
              v-for="menuData in filteredItemData"
              :id="'item' + menuData.restaurant_menu_id"
              :key="menuData.restaurant_menu_id"
            >
              <div class="media-heading">
                <h4 class="mb-4">{{ menuData.menu_name }}</h4>
              </div>
              <div
                class="media-itms"
                :class="
                  'media-itms-theme' +
                  (itemlayout == null || itemlayout == '' ? '1' : itemlayout)
                "
              >
                <Product
                  v-for="item in menuData.items"
                  :key="item.item_id"
                  :item="item"
                  :right="true"
                  :menuId="menuData.restaurant_menu_id"
                  v-on:openProductDetailModal="openProductDeails"
                  :restaurantID="item.restaurant_id"
                  :restaurant_on_off="restaurant_on_off"
                  :class="item.item_id"
                  :pagename="pageName"
                  :itemlayout="
                    itemlayout == null || itemlayout == '' ? '1' : itemlayout
                  "
                  :restautantDetails="restautantDetails"
                ></Product>
              </div>
            </section>
          </div>

          <!--- Single "No Item Found" message --->
          <div v-else class="home-res-not-found h-100 align-items-lg-center d-flex  justify-content-center">
            <div class="nostr-img-cls">
              <img src="@/assets/images/no_search.png" />
              <h6>{{ $t("No Item Found") }}</h6>
              <span>{{ $t("Please remove filters to see items.") }}</span>
            </div>
          </div>
        </div>

        <div class="mt-auto">
          <Footer></Footer>
        </div>
      </div>
    </div>

    <ProductDetails
      ref="childComponent"
      :restaurantID="restaurantID"
      :restaurant_on_off="restaurant_on_off"
      :pagename="pageName"
    ></ProductDetails>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Product from "@/components/Product.vue";
import ProductDetails from "@/components/ProductDetails.vue";
import MenuCategory from "@/components/MenuCategory.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import Footer from "../components/Footer.vue";

export default {
  components: {
    Product,
    ProductDetails,
    MenuCategory,
    "skeleton-loader-vue": VueSkeletonLoader,
    Footer,
  },
  props: ["restaurant_on_off", "restautantDetails", "search"],
  data() {
    return {
      menus: [],
      restaurantID: "",
      selectedSection: 0,
      vendorID: "",
      date: "",
      starttime: "",
      productDetails: { type: Object },
      active_el: 0,
      loading: true,
      pageName: "itemslist",
      routerItemId: 0,
      routerItemIdStatus: true,
      is_menu_category: false,
      cateMenus: [],
      menuCategryId: 0,
      is_menu_skel_loader: true,
      menusdata: {},
      isSearchHide: true,
      itemlayout: "1",
      newCateClassAdd: "",
      itemTypeFilterKey: "",
      itemType: [],
      typeUniqNumbers: [],
      selectType: [],
      listItemVeg: [],
      restTags: [],
      recommendedList: [],
      emptyMenuId: "",
    };
  },

  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),

    filteredData() {
      this.recommendedList = [];
      return Object.keys(this.menus).reduce((a, cKey) => {
        const data = this.filterValue(this.menus[cKey]);
        if (data && data.length) {
          let menuName = this.menus[cKey].menu_name;
          let nerecomm = data.find((itm) => itm.is_featured == "1");
          if (nerecomm) {
            this.recommendedList.push(nerecomm);
          }
          a[cKey] = {
            items: data,
            menu_name: menuName,
            item_counts: data.length,
            restaurant_menu_id: this.menus[cKey].restaurant_menu_id,
          };
        } else {
          a[cKey] = {
            items: [],
            menu_name: this.menus[cKey].menu_name,
            item_counts: 0,
            restaurant_menu_id: this.menus[cKey].restaurant_menu_id,
          };
        }
        if (this.selectType.length == 0) {
          this.filterItemType();
        }
        return a;
      }, {});
    },

    hasItemsToDisplay() {
      return (
        (this.menus &&
          Object.keys(this.menus).length > 0 &&
          Object.keys(this.menusdata).length == 0) ||
        Object.values(this.filteredData).some(
          (menuData) => menuData.items && menuData.items.length > 0
        )
      );
    },

    filteredItemData() {
      this.recommendedList = [];
      const data = this.filterValue(this.menusdata);
      if (data && data.length) {
        let result = {
          items: data,
          menu_name: this.menusdata.menu_name,
          item_counts: data.length,
          restaurant_menu_id: this.menusdata.restaurant_menu_id,
        };
        data.forEach((item) => {
          if (["0", "1", "2"].includes(item.item_type)) {
            this.itemType.push(item.item_type);
          }
        });
        if (this.selectType.length == 0) {
          this.filterItemType();
        }
        return [result];
      }
      return [];
    },
  },

  mounted() {
    let routerHasValue = this.$route.hash;
    if (routerHasValue) {
      this.routerItemId = routerHasValue.replace("#item", "");
    }
    this.vendorID = this.$auth.getVendorId();
    this.restaurantID =
      this.restautantDetails && this.restautantDetails.restaurant_id;
    this.itemlayout =
      this.restautantDetails && this.restautantDetails.restaurant_item_layout;
    if (this.itemlayout == "") {
      this.itemlayout = "1";
    }

    if (
      this.restautantDetails &&
      this.$auth.setting &&
      this.restautantDetails.item_counts > this.$auth.setting.item_counts
    ) {
      this.isSearchHide = false;
      this.getCategoryWiseMenuList();
    } else {
      if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count < 0
      ) {
        this.getCategoryWiseMenuList();
      } else {
        this.isSearchHide = true;
        this.getCategoryWiseMenuList();
      }
    }
    this.restTags = this.restautantDetails.restaurant_tags;
  },

  methods: {
    ...mapActions("product", ["getMenuProductList"]),
    ...mapActions("restaurant", [
      "getRestaurantMenuCategoryList",
      "getMenuWiseItem",
      "getCategoryWiseMenu",
    ]),

    filterItemType() {
      let uniqueType = [];
      if (this.itemType.length > 0) {
        $.each(this.itemType, function (i, el) {
          if ($.inArray(el, uniqueType) === -1) uniqueType.push(el);
        });
      }
      if (uniqueType.length == 1 && !uniqueType.includes("2")) {
        this.listItemVeg = uniqueType;
      }
      return uniqueType;
    },

    itemFilterClick(type, tag) {
      if (this.selectType.indexOf(type) === -1) {
        this.selectType.push(type);
      } else {
        let newArray = this.selectType.filter((e) => e !== type);
        this.selectType = newArray;
      }
    },

    filterValue(content) {
      let itemProduct = content.menu_item_detail;
      if (itemProduct) {
        return itemProduct.filter((item) => {
          if (this.selectType.length > 0) {
            let newdata = this.selectType.findIndex(
              (type) => type === item.item_type
            );
            let newTagsSearch = this.selectType.findIndex((type) =>
              item.item_tags.some((x) => x.name == type)
            );
            if (newdata != -1 || newTagsSearch != -1) {
              return item;
            }
          } else {
            let itemUpper = item.item_name.toLowerCase();
            let searchUpper = this.search.toLowerCase();
            return itemUpper.indexOf(searchUpper) > -1;
          }
        });
      }
      return [];
    },

    openMenuCategoryList(id) {
      this.recommendedList = [];
      this.menus = [];
      this.menuCategryId = id;
      this.categoryMenuProduct();
    },

    categoryMenuProduct() {
      this.loading = true;
      this.is_menu_skel_loader = true;
      this.getMenuProductList({
        date: "",
        brand_id: this.restautantDetails.brand_id,
        restaurant_id: this.restaurantID,
        vendor_id: this.vendorID,
        skip: 0,
        starttime: "",
        is_langauge: this.$store.state.lang.locale,
        total_record: 1000,
        cityname: "",
        latitude: localStorage.getItem("latitude"),
        delivery_type_time_slots: this.isPickupDelivery,
        menu_category_id: this.menuCategryId,
        longitude: localStorage.getItem("longitude"),
      }).then((data) => {
        if (data.code == 200) {
          this.loading = false;
          this.menus = data.Result;
          let itemtypeArray = [];
          this.menus.forEach((element) => {
            if (
              element.menu_item_detail &&
              element.menu_item_detail.length > 0
            ) {
              element.menu_item_detail.forEach((elm) => {
                itemtypeArray.push(elm.item_type);
              });
            }
          });
          this.routerItemId = localStorage.getItem("menuCatID");
          this.itemType = itemtypeArray;
          let findfirst = this.menus.find((el) => el.item_counts > 0);
          if (findfirst && this.recommendedList.length > 0) {
            this.active_el = findfirst.restaurant_menu_id;
          }
          if (this.routerItemId > 0) {
            setTimeout(() => this.activeMenu(this.routerItemId), 1200);
          }
          let element = document.getElementById(
            "menucateID-" + this.menuCategryId
          );
          $(".menucate-cls").removeClass("active");
          if (element != null) {
            element.className += " active";
          }
          this.is_menu_skel_loader = false;
        } else if (data.code == 101) {
          this.menus = [];
          this.is_menu_skel_loader = false;
          this.loading = false;
        } else {
          this.is_menu_skel_loader = false;
          this.loading = false;
        }
      });
    },

    openProductDeails(value) {
      window.$("#item-popup").modal("show");
      window.$("#item-popup").on("hidden.bs.modal", () => {
        if (this.$refs.childComponent) {
          if (!this.$refs.childComponent.productDetail) {
            this.$refs.childComponent.productDetail = {};
          }
          this.$refs.childComponent.productDetail = null;
          this.$refs.childComponent.selectedCustomisation = {
            customize_type: {},
          };
        }
      });
      if (this.$refs.childComponent) {
        this.$refs.childComponent.openProductModel(value.item_id);
      }
    },

    async activeMenu(itemId) {
      let id = "item" + itemId;
      this.selectedSection = id;
      if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count == 0
      ) {
        this.is_menu_skel_loader = true;
        this.menusdata = {};
        await this.getMenuWiseItemList(itemId);
      }
    },

    getCategoryWiseMenuList() {
      if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count == 0
      ) {
        this.is_menu_category = false;
        this.loading = true;
        this.getCategoryWiseMenu({
          date: "",
          brand_id: this.restautantDetails.brand_id,
          restaurant_id: this.restaurantID,
          vendor_id: this.vendorID,
          starttime: "",
          is_langauge: this.$store.state.lang.locale,
        }).then((data) => {
          if (data.code == 200) {
            this.loading = false;
            this.is_menu_skel_loader = false;
            this.menus = data.Result;
            let findfirst = this.menus.find((el) => el.item_counts > 0);
            if (findfirst) {
              this.active_el = findfirst.restaurant_menu_id;
              this.getMenuWiseItemList(findfirst.restaurant_menu_id);
            }
          } else {
            this.is_menu_skel_loader = false;
            this.loading = false;
          }
        });
      } else if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count > 0
      ) {
        this.is_menu_category = true;
        this.getRestaurantMenuCategoryList({
          brand_id: this.restautantDetails.brand_id,
          restaurant_id: this.restaurantID,
          vendor_id: this.vendorID,
          is_langauge: this.$store.state.lang.locale,
          latitude: localStorage.getItem("latitude"),
          longitude: localStorage.getItem("longitude"),
        }).then((data) => {
          if (data.code == 200) {
            this.loading = false;
            this.cateMenus = data.Result;
            this.newCateClassAdd = "cateNewClass";
            if (
              localStorage.getItem("menuCatID") == null ||
              localStorage.getItem("menuCatID") == ""
            ) {
              if (this.cateMenus && this.cateMenus[0]) {
                this.menuCategryId = this.cateMenus[0].id;
                this.categoryMenuProduct();
              }
            } else {
              this.openMenuCategoryList(localStorage.getItem("menuCatID"));
              localStorage.setItem("menuCatID", "");
            }
          } else {
            this.is_menu_skel_loader = false;
            this.loading = false;
          }
        });
      }
    },

    getMenuWiseItemList(itemId) {
      this.is_menu_category = false;
      this.loading = true;
      this.getMenuWiseItem({
        date: "",
        brand_id: this.restautantDetails.brand_id,
        restaurant_id: this.restaurantID,
        vendor_id: this.vendorID,
        skip: 0,
        starttime: "",
        is_langauge: this.$store.state.lang.locale,
        total_record: 10000,
        menu_id: itemId,
      }).then((data) => {
        if (data.code == 200) {
          this.loading = false;
          this.is_menu_skel_loader = false;
          this.menusdata = data.Result[0] || {};
        } else {
          this.loading = false;
          this.is_menu_skel_loader = false;
        }
      });
    },
  },
};
</script>

<style>
.menuSkel {
  border-radius: 30px !important;
}

.skel-loader {
  display: flex;
}

.sticcitem img {
  height: 30px;
  object-fit: contain;
}

.menulength {
  margin: 40px 0px !important;
  height: 100% !important;
}
</style>